export default {
  filters: {
    today: 'Astăzi',
    yesterday: 'Ieri',
    this_week: 'Săptămâna aceasta',
    last_week: 'Săptămâna trecută',
    this_month: 'Luna aceasta',
    last_month: 'Luna trecută',
    all: 'Toate',
  },
};
